export default "__VITE_ASSET__zNmuuu29__"